module.exports = __webpack_public_path__ + "static/media/crunchyroll.42e11ad7.png";